import React, {useContext, useEffect, useReducer, useState} from "react";
import {ActionSheet, Badge, Modal, NavBar, Tabs, Toast, WingBlank} from 'antd-mobile';
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import StepOne from "./StepOne";
import {extractKeywords, objectReplaceReducer} from "../lib/utils";
import {useBizTypes, useFormData, useLogin, usePresenatation} from "../lib/bridgeHooks";
import MailForm from "../forms/MailForm";
import DownloadForm from "../forms/DownloadForm";
import exportOutlined from "@iconify/icons-ant-design/export-outlined";
import loginOutlined from "@iconify/icons-ant-design/login-outlined";
import printerFilled from "@iconify/icons-ant-design/printer-filled";
import {Icon} from "@iconify/react";
import filePdfFilled from "@iconify/icons-ant-design/file-pdf-filled";
import mailFilled from "@iconify/icons-ant-design/mail-filled";
import plusSquareFilled from "@iconify/icons-ant-design/plus-square-filled";
import * as PropTypes from "prop-types";
import {ClientBridge} from "../index";
import Copyright from "./Copyright";
import Intro from "./Intro";
import {find} from 'lodash';


const modalAlert = Modal.alert;

function Tab({done, label, error}) {
    const ballotX = "\u{2717}";
    const checkMark = "\u{2713}";

    return error
        ? <Badge text={ballotX} style={{backgroundColor: "red"}}>{label}</Badge>
            : done
            ? <Badge text={checkMark} style={{backgroundColor: "#4dd865"}}>{label}</Badge>
            : <span>{label}</span>;
}


const exportActions = [
    { icon: printerFilled, title: 'Print', action: 'print'},
    { icon: filePdfFilled, title: 'Download PDF', action:'pdf' },
    { icon: mailFilled, title: 'Email', action: 'email' },
    { icon: plusSquareFilled, title: "Add to\nPresentation", action: 'add' }
].map(obj => ({
    icon: <Icon icon={obj.icon} style={{fontSize:45}}/>,
    title: obj.title,
    action: obj.action
}));


export default function WizardSteps({menu, title, mccNav}) {

    const [cbFormData, setCbFormData] = useFormData();  // get desktop data from client bridge
    const [page, setPage] = useState(0);
    const [company, setCompany] = useReducer(objectReplaceReducer, {});
    const [template, setTemplate] = useState();
    const [blackAndWhite, setBlackAndWhite] = useState(false);  //todo fuller output object
    const [adStatus, setAdStatus] = useState('');
    const {bizLookup} = useBizTypes();
    const [defaultKeyword, setDefaultKeyword] = useState('');
    const [introVisible, setIntroVisible] = useState(true);
    const [showMail, setShowMail] = useState(false);
    const [showDownload, setShowDownload] = useState(false);
    const [showPrint, setShowPrint] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [emailInfo,  setEmailInfo] = useState({});
    const clientBridge = useContext(ClientBridge);
    const {profile, user, login, adServices} = useLogin();
    const presentation = usePresenatation();
    const [presStatus, setPresStatus ] = useState('none');

    const isRelevanceProject = profile.USERTYPE === 'RelevanceProject' ;

    useEffect(()=>{
        if (presStatus!=='search') {
            const biz = company.type || company.category || '';
            console.log('keyword from biztype');
            setDefaultKeyword(biz in bizLookup ? bizLookup[biz].keywords : extractKeywords(biz));
        }
    },[company,  bizLookup,presStatus]);
    // todo - which one wins?
    useEffect(()=>{
        if (presentation.ad_id) {
            console.log('keyword from presentation');
            setDefaultKeyword(presentation.ad_id);
            setPresStatus('search');
            setIntroVisible(false);
        }
    },[presentation]);

    const recordsChanged = (records) =>{
        //if (presentation.ad_id && !template){ // && records.length) {
        if (presStatus === 'search') {
            const asset =  find(records, {file_base:presentation.ad_id});
            if (asset) {
                setTemplate(asset);
                setPresStatus('render');
            } else {
                setPresStatus('notFound');
            }
        } else {
            setPresStatus('none');
        }
    };

    useEffect(()=>{
        if (template && company.name) {
            setPage(2);
            setAdStatus('building...');
        } else
        {
            setAdStatus('');
            if (company.name) {
                // Apparently this unwanted too
                //setPage(1)
            } else if (template) {
                // flips you back... confusing
                //setPage(0)
            }
        }
    },[template, company, blackAndWhite]);

    useEffect(()=>{
        console.log('wsteps grabbing');
        setCompany(cbFormData.company);
    },[cbFormData]);

    useEffect(()=>{
        console.log('wstep saving: '+company.type);

        setCbFormData((data)=>{
            data.company = company;
            return data;
        });
    },[company,setCbFormData]);

//todo Page or Step component

    useEffect(()=>{
        if (adStatus==='done') {
            setEmailInfo({
                to: '',
                from: profile.CN,
                replyTo: profile.EMAIL,
                subject: `New Spec Ad for ${company.name}`,
                message: '',
                bcc: true
            });
        }
    },[adStatus,company,profile]);


    const showShareActionSheet = () => {

        const actions = presentation.id
            ? exportActions //all
            : exportActions.slice(0,3);  // omit last

        ActionSheet.showShareActionSheetWithOptions({
                options: actions,
                title: 'Spec Ad Actions',
                cancelButtonText: 'Cancel'
            },
            (buttonIndex) => {
                const action = buttonIndex > -1 ? actions[buttonIndex].action : 'cancel';

                if (action === 'email') {
                    setShowMail(true);
                } else if (action === 'pdf') {
                    setShowDownload(true);
                } else if (action === 'print') {
                    setShowPrint(true);
                } else if (action === 'add') {
                    setShowAdd(true);
                }
            });
    };

    const clickedShare = ()=> {

        const allowed = clientBridge.connected ? clientBridge.wizard.assetAuth() : true;

        if (allowed === true) {
            showShareActionSheet();
        } else {
            modalAlert(
                'Unauthorized',
                <WingBlank><p
                    dangerouslySetInnerHTML={{
                        __html: allowed
                    }}
                /></WingBlank>,
                [{text: 'OK', onPress: () => console.log('ok') },]
            );
        }
    };

    const sendEmail = async (emailForm) => {
        if (clientBridge.connected) {
            //todo make this a async hook
            try {
                await clientBridge.wizard.emailLastRender(emailForm);
                Toast.success('Email sent');
            } catch (e) {
                console.error('Email failed: '+template.name);
                console.dir(e);
                Toast.info('Send email failed');
            }
        } else {
            Toast.info('send email...');
        }
    };

    const downloadPdf = async (printForm) => {
        if (clientBridge.connected) {
            //todo make this a async hook
            try {
                await clientBridge.wizard.mobileDownloadPdf(printForm);
                //Toast.success('eamil sent');
            } catch (e) {
                console.error('download pdf failed: '+template.name);
                console.dir(e);
                Toast.info('Download PDF failed');
            }
        } else {
            Toast.info('download...');
        }
    };

    const addToPresentation = (asset) => {
        if (clientBridge.connected) {
            try {
                // todo ?Altering mcc wizard object - should be...
                presentation.ad_id = asset.file_base ;
                if ('adseller' in mccNav) {
                    mccNav.adseller();
                }
            } catch (e) {
                console.error('add to Ad Seller presentation failed: '+template.name);
                console.dir(e);
                Toast.info('Add to presentation failed');
            }
        } else {
            Toast.info('Selected...');
        }
    };

    const printHtml = printForm => {
        if (clientBridge.connected) {
            clientBridge.wizard.mobilePrint(printForm);
        } else {
            Toast.info('print...');
        }
    };

    const resetWizard = ()=>{
        setPage(0);
        setIntroVisible(true);
        //TODO clear data
    };

    //return (<div>Wizard Steps</div>)

    return (
        <div style={{textAlign:'center'}}>
            <NavBar
                mode="dark"
                rightContent={menu}
                leftContent={[
                    user==='guest' &&
                    <Icon
                            icon={loginOutlined}
                            style={{ fontSize: '32px', marginRight:'8px'}}
                            onClick={()=>login()}
                    />,
                    adStatus==='done' &&
                    <Icon
                        icon={exportOutlined}
                        style={{ fontSize: '32px', transform: 'rotate(-90deg)'}}
                        onClick={clickedShare}/>
                ]}
            ><span onClick={resetWizard}>{title}</span></NavBar>
            <Tabs
                tabs={[
                    { title: <Tab label={'Advertiser'} done={company.name} error={!company.name && page!==0}/> },
                    { title: <Tab label={'Template'} done={template} error={!template && page===2}/> },
                    { title: <Tab label={'Spec Ad'} done={adStatus==='done'}
                                  error={adStatus==='failed'}/>},
                ]}
                page={page}
                onTabClick={(tab, index) => {
                      setPage(index);
                }}
                onChange={(tab, index) => {
                    setPage(index);
                }}
                prerenderingSiblingsNumber={2}  // ensures Step One is rendered when skipping to Three so isVisible ie evaluated
            >
                <StepOne
                    setCompany={setCompany}
                    company={company}
                    isVisible={page===0}
                    done={()=>setPage(template ? 2 :1)}
                />
                <StepTwo
                    {...{setTemplate, setBlackAndWhite, blackAndWhite, company, user, adServices, recordsChanged}}
                    defaultKeyword={defaultKeyword}
                    isVisible={page===1}
                    hideQuery={isRelevanceProject}
                />
                <StepThree
                    {...{template, company, adStatus, setAdStatus, setBlackAndWhite, blackAndWhite}}
                    isVisible={page===2}
                />
            </Tabs>

            <Copyright/>

            <Modal
                visible={introVisible}
                title="Metro Creative Connection Ad Wizard"
                transparent
                footer={[{
                    text: (user==='guest' ? 'Login & ' : '' ) +'Get started!',
                    onPress: () => { setIntroVisible(false) }
                }]}
                //wrapProps={{ onTouchStart: onWrapTouchStart }}
            >
                <Intro/>
            </Modal>

            <PopupModal
                visible={showMail}
                onClose={() => setShowMail(false)}
            >
                <MailForm
                    message={emailInfo}
                    onSubmit={(values) => {
                        sendEmail(values);
                        setShowMail(false);
                    }}
                    onCancel={()=>setShowMail(false)}
                    showReset={true}
                    allowSubmitNoTouch={true}
                />
            </PopupModal>

            <PopupModal
                visible={showDownload}
                onClose={()=>setShowDownload(false)}
            >
                <DownloadForm
                    onSubmit={(values) => {
                        downloadPdf(values);
                        setShowDownload(false);
                    }}
                    onCancel={()=>setShowDownload(false)}
                    allowSubmitNoTouch={true}
                />
            </PopupModal>

            <PopupModal
                visible={showPrint}
                onClose={()=>setShowPrint(false)}
            >
                <DownloadForm
                    onSubmit={(values) => {
                        printHtml(values);
                        setShowPrint(false);
                    }}
                    onCancel={()=>setShowPrint(false)}
                    allowSubmitNoTouch={true}
                    headerText={'Print details'}
                    submitText={'View Preview'}
                />
            </PopupModal>

            <Modal
                visible={showAdd}
                onClose={()=>setShowAdd(false)}
                title={template && template.name}
                transparent
                onCancel={()=>setShowAdd(false)}
                footer={[
                        {text: "Cancel", onPress: ()=>setShowAdd(false)},
                        {text: "Add", onPress: ()=>{
                            addToPresentation(template);
                            setShowAdd(false);
                        }},
                    ]}
            >
                {template && <img
                    src={template.getPreviewUrl()}
                    alt={template.name}
                    style={{width: "100%"}}
                />}
                <div>Add Spec Ad to presentation and return to Ad Seller</div>
            </Modal>
        </div>
    );
}

/*
const TabPanel = (props)=>(
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff' }}>
        {props.children}
    </div>
);
 */

function PopupModal({visible, children, ...props}) {

    return <Modal
        visible={visible}
        animationType="slide-up"
        popup
        {...props}
    >{children}
    </Modal>;
}
PopupModal.propTypes = {
    visible: PropTypes.bool,
    onClose: PropTypes.func.isRequired
};
